<template>
<main class="-mt-32 lg:-mt-20 relative z-10">
  <div class="wrap">
    <div class="bg" />
    <div class="inner">
      <p class="h1">
        <template v-if="location">{{ location }}の倉庫探しなら<span class="hidden md:inline">ウェアエックス</span></template>
        <img src="@/assets/img/index/main-logo.svg" width="341" alt="">
      </p>
      <ul class="panels">
        <li>
          <p class="img"><img width="27" src="@/assets/img/index/feature-icon3.svg" alt=""></p>
          <span>最短3日で利用<br class="hidden md:block" />少量OK</span>
        </li>
        <li>
          <p class="img"><img width="24" src="@/assets/img/index/feature-icon1.svg" alt=""></p>
          <span>輸配送・入出荷<br class="hidden md:block" />サポートあり</span>
        </li>
        <li>
          <p class="img"><img width="18" src="@/assets/img/index/feature-icon2.svg" alt=""></p>
          <span>コストは<br class="hidden md:block" />利用分だけ</span>
        </li>
      </ul>
    </div>
  </div>
</main>
</template>

<style lang="sass" scoped>
.wrap
  min-height: 300px
  @apply px-6 pt-24 relative bg-black mb-10
  @screen md
    @apply px-10 pb-10 mb-6
  @screen lg
    @apply mb-0 pt-12
  @screen xl
    @apply px-32
.inner
  @apply relative pt-16 pb-8
  @screen lg
    @apply flex items-end pt-10 pb-8
.bg
  @apply absolute inset-0 bg-cover
  opacity: .65
  background-position: center top
  background-image: url(~@/assets/img/index/main_bg.jpg)
.h1
  font-size: 15px
  @apply text-orange text-center font-bold mt-8 tracking-widest
  img
    width: 177px
    @apply mx-auto mt-2
  @screen md
    @apply mb-6
  @screen lg
    text-align-last: justify
    @apply text-base mb-0
    img
      width: 340px
.panels
  padding: 12px 16px 10px 14px
  @apply bg-white rounded-xl mt-6 ml-6
  li
    @apply flex items-center py-1
    span
      @apply text-black font-semibold ml-2
    .img
      min-width: 30px
      img
        @apply mx-auto
  @screen md
    @apply bg-transparent mt-0 p-0 flex justify-center
    li
      padding: 16px 16px 13px 14px
      @apply bg-white w-48 rounded mr-2
      img
        @apply w-auto
</style>

<script>
export default {
  props: {
    location: {
      type: String,
      default: null
    }
  }
}
</script>